import React from 'react';
import styles from './LimitReportsIcon.module.scss';
import { SFIcon, SFTooltip } from 'sfui';
import { InteractiveBox } from 'ui-smartforce-settings';
import { isMobile } from '../../../../../../../../../Helpers';
import { INITIATIVE_REPORTS_LIMIT } from '../InitiativeCardDetailsList';

export interface LimitReportsIconProps {}

export const LimitReportsIcon = (
  props: LimitReportsIconProps
): React.ReactElement<LimitReportsIconProps> => {
  const [isTooltipOpen, setIsTooltipOpen] = React.useState<boolean>(false);

  const onInfoClick = () => {
    setIsTooltipOpen(true);
  };

  const onInfoClose = () => {
    setIsTooltipOpen(false);
  };

  const TOOLTIP_MESSAGE = `Showing the ${INITIATIVE_REPORTS_LIMIT} most recent results, based on these initiative settings.`;

  return (
    <SFTooltip
      title={TOOLTIP_MESSAGE}
      placement="bottom"
      open={isMobile() ? isTooltipOpen : undefined}
      onClose={onInfoClose}
      disableHoverListener={isMobile()}
      PopperProps={{ disablePortal: true, style: { zIndex: 1199 } }}
    >
      <InteractiveBox className={styles.limitReportsIcon} onClick={onInfoClick}>
        <SFIcon icon="Information" size={13} />
      </InteractiveBox>
    </SFTooltip>
  );
};
